import { Action } from '@ngrx/store';
import { ServiceCategoryModel, ServiceMasterCategoryModel, ServiceModel } from './model';

export enum ActionTypes {
  FAILURE = '[ServiceCatalog] Failure',

  GET_ALL_REQUEST = '[ServiceCatalog] GetAll Request',
  GET_ALL_SUCCESS = '[ServiceCatalog] GetAll Success',

  ENABLE_REQUEST = '[ServiceCatalog] Enable Request',
  ENABLE_SUCCESS = '[ServiceCatalog] Enable Success',

  DISABLE_REQUEST = '[ServiceCatalog] Disable Request',
  DISABLE_SUCCESS = '[ServiceCatalog] Disable Success',

  SYNC_REQUEST = '[ServiceCatalog] Sync Request',
  //SYNC_SUCCESS = '[ServiceCatalog] Sync Success'

  FILTER_REQUEST = '[ServiceCatalog] Filter Request',
  FILTER_SUCCESS = '[ServiceCatalog] Filter Success',

  UPDATE_SERVICE_REQUEST = '[ServiceCatalog] UpdateService Request',
  UPDATE_SERVICE_SUCCESS = '[ServiceCatalog] UpdateService Success',

  UPDATE_CATEGORY_REQUEST = '[ServiceCatalog] UpdateCategory Request',

  UPLOAD_CATEGORY_ICON_REQUEST = '[ServiceCatalog] UploadCategoryIcon Request',
  DELETE_CATEGORY_ICON_REQUEST = '[ServiceCatalog] DeleteCategoryIcon Request',

  UP_PRIORITY_CATEGORY_REQUEST = '[ServiceCatalog] UpPriorityCategory Request',
  DOWN_PRIORITY_CATEGORY_REQUEST = '[ServiceCatalog] DownPriorityCategory Request',

  UP_PRIORITY_MASTER_CATEGORY_REQUEST = '[ServiceCatalog] UpPriorityMasterCategory Request',
  DOWN_PRIORITY_MASTER_CATEGORY_REQUEST = '[ServiceCatalog] DownPriorityMasterCategory Request',

  UPLOAD_MASTER_CATEGORY_ICON_REQUEST = '[ServiceCatalog] UploadMasterCategoryIcon Request',
  DELETE_MASTER_CATEGORY_ICON_REQUEST = '[ServiceCatalog] DeleteMasterCategoryIcon Request',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}

export class GetAllRequestAction implements Action {
  readonly type = ActionTypes.GET_ALL_REQUEST;
  constructor() {}
}

export class GetAllSuccessAction implements Action {
  readonly type = ActionTypes.GET_ALL_SUCCESS;
  constructor(public entities: ServiceModel[]) {}
}

export class EnableRequestAction implements Action {
  readonly type = ActionTypes.ENABLE_REQUEST;
  constructor(public codes: number[]) {}
}

export class EnableSuccessAction implements Action {
  readonly type = ActionTypes.ENABLE_SUCCESS;
  constructor(public entities: ServiceModel[]) {}
}

export class DisableRequestAction implements Action {
  readonly type = ActionTypes.DISABLE_REQUEST;
  constructor(public codes: number[]) {}
}

export class DisableSuccessAction implements Action {
  readonly type = ActionTypes.DISABLE_SUCCESS;
  constructor(public entities: ServiceModel[]) {}
}

export class SyncRequestAction implements Action {
  readonly type = ActionTypes.SYNC_REQUEST;
  constructor() {}
}

export class FilterRequestAction implements Action {
  readonly type = ActionTypes.FILTER_REQUEST;
  constructor() {}
}

export class FilterSuccessAction implements Action {
  readonly type = ActionTypes.FILTER_SUCCESS;
  constructor(public entities: ServiceModel[]) {}
}

//export class SyncSuccessAction implements Action {
//  readonly type = ActionTypes.SYNC_SUCCESS;
//  constructor(public entities: ServiceModel[]) { }
//}

export class UpdateServiceRequestAction implements Action {
  readonly type = ActionTypes.UPDATE_SERVICE_REQUEST;
  constructor(public service: ServiceModel) {}
}

export class UpdateServiceSuccessAction implements Action {
  readonly type = ActionTypes.UPDATE_SERVICE_SUCCESS;
  constructor(public entity: ServiceModel) {}
}

export class UpdateCategoryRequestAction implements Action {
  readonly type = ActionTypes.UPDATE_CATEGORY_REQUEST;
  constructor(public category: ServiceCategoryModel) {}
}

export class UploadCategoryIconRequestAction implements Action {
  readonly type = ActionTypes.UPLOAD_CATEGORY_ICON_REQUEST;
  constructor(
    public category: ServiceCategoryModel,
    public file: File
  ) {}
}

export class DeleteCategoryIconRequestAction implements Action {
  readonly type = ActionTypes.DELETE_CATEGORY_ICON_REQUEST;
  constructor(public category: ServiceCategoryModel) {}
}

export class UploadMasterCategoryIconRequestAction implements Action {
  readonly type = ActionTypes.UPLOAD_MASTER_CATEGORY_ICON_REQUEST;
  constructor(
    public masterCategory: ServiceMasterCategoryModel,
    public file: File
  ) {}
}

export class DeleteMasterCategoryIconRequestAction implements Action {
  readonly type = ActionTypes.DELETE_MASTER_CATEGORY_ICON_REQUEST;
  constructor(public masterCategory: ServiceMasterCategoryModel) {}
}

export class UpPriorityCategoryRequestAction implements Action {
  readonly type = ActionTypes.UP_PRIORITY_CATEGORY_REQUEST;
  constructor(public category: ServiceCategoryModel) {}
}

export class DownPriorityCategoryRequestAction implements Action {
  readonly type = ActionTypes.DOWN_PRIORITY_CATEGORY_REQUEST;
  constructor(public category: ServiceCategoryModel) {}
}

export class UpPriorityMasterCategoryRequestAction implements Action {
  readonly type = ActionTypes.UP_PRIORITY_MASTER_CATEGORY_REQUEST;
  constructor(public masterCategory: ServiceMasterCategoryModel) {}
}

export class DownPriorityMasterCategoryRequestAction implements Action {
  readonly type = ActionTypes.DOWN_PRIORITY_MASTER_CATEGORY_REQUEST;
  constructor(public masterCategory: ServiceMasterCategoryModel) {}
}

export type Actions =
  | FailureAction
  | GetAllRequestAction
  | GetAllSuccessAction
  | EnableRequestAction
  | EnableSuccessAction
  | DisableRequestAction
  | DisableSuccessAction
  | SyncRequestAction //SyncSuccessAction
  | FilterRequestAction
  | FilterSuccessAction
  | UploadCategoryIconRequestAction
  | DeleteCategoryIconRequestAction
  | UploadMasterCategoryIconRequestAction
  | DeleteMasterCategoryIconRequestAction
  | UpdateCategoryRequestAction
  | UpdateServiceRequestAction
  | UpdateServiceSuccessAction;
